// Using an ES6 transpiler like Babel
import React from 'react';
import DatePicker from 'react-mobile-datepicker';

const DatePickerComponent = ({ value, dateIsOpen, handleSelect, handleCancel }) => {

  const monthMap = {
    '1': 'Jan',
    '2': 'Feb',
    '3': 'Mar',
    '4': 'Apr',
    '5': 'Mei',
    '6': 'Jun',
    '7': 'Jul',
    '8': 'Aug',
    '9': 'Sep',
    '10': 'Okt',
    '11': 'Nov',
    '12': 'Des',
  };

  const dateConfig = {
    'year': {
      format: 'YYYY',
      caption: 'Year',
      step: 1,
    },
    'month': {
      format: value => monthMap[value.getMonth() + 1],
      caption: 'Mon',
      step: 1,
    },
    'date': {
      format: 'DD',
      caption: 'Day',
      step: 1,
    },
  };

  let today = new Date()
  let maxYear = new Date()
  let minYear = new Date()
  let day = today.getDate()
  let month = today.getMonth() //January is 0
  let year = today.getFullYear() - 15
  let min = today.getFullYear() - 100
  if (day < 10) {
    day = '0' + day
  }
  if (month < 10) {
    month = month - 1
  }
  maxYear = new Date(year, month, day)
  minYear = new Date(min, month, day)

  return (
    <DatePicker
      value={value}
      isOpen={dateIsOpen}
      onSelect={(time) => {
        handleSelect(time)
      }}
      onCancel={() => handleCancel()}
      confirmText='Simpan'
      cancelText='Batal'
      theme='default'
      showHeader={false}
      max={maxYear}
      min={minYear}
      dateConfig={dateConfig}
    />
  )
}

export default DatePickerComponent